import React from 'react';

import { Box, Typography } from '@mui/material';

import { getEffect } from '../../../Effects';
import {
  getColorFromAge,
  getColorFromTicks,
} from '../../../helpers/ColorFormatting';

interface Props {
  useBlocks?: boolean;
}
const Legend: React.FC<Props> = ({ useBlocks }) => {
  const getSpellLegend = (ticks: number) => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {getEffect('FERTILELANDS', ticks)}
        <Typography
          variant='body2'
          component={useBlocks ? 'div' : 'span'}
          sx={{ color: getColorFromTicks(ticks), marginRight: 1 }}
        >
          {ticks} Ticks
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <Typography variant='body1' component='div' mx={1}>
        Color Guide
      </Typography>
      <Box
        sx={{
          mx: 1,
          mb: 2
        }}>
        <Typography
          variant='body2'
          component={useBlocks ? 'div' : 'span'}
          sx={{ color: getColorFromAge(3500), marginRight: 1 }}
        >
          0-60m (new)
        </Typography>
        <Typography
          variant='body2'
          component={useBlocks ? 'div' : 'span'}
          sx={{ color: getColorFromAge(14300), marginRight: 1 }}
        >
          1hr-4hr (fresh)
        </Typography>
        <Typography
          variant='body2'
          component={useBlocks ? 'div' : 'span'}
          sx={{ color: getColorFromAge(28700), marginRight: 1 }}
        >
          4hr-8hr (not fresh)
        </Typography>
        <Typography
          variant='body2'
          component={useBlocks ? 'div' : 'span'}
          sx={{ color: getColorFromAge(28900), marginRight: 1 }}
        >
          8 Hours or more (not to be trusted)
        </Typography>
      </Box>
      <Box
        sx={{
          mx: 1,
          mb: 2
        }}>
        <Box
          sx={{
            display: useBlocks ? 'block' : 'flex',
            alignItems: 'center',
          }}
        >
          {getSpellLegend(12)}
          {getSpellLegend(10)}
          {getSpellLegend(8)}
          {getSpellLegend(6)}
          {getSpellLegend(4)}
          {getSpellLegend(2)}
          {getSpellLegend(1)}
          {getSpellLegend(0)}
        </Box>
      </Box>
      {/* <Box mb={2} mx={1}>
        <Typography variant='body1' component='div'>
          What&#39;s new?
        </Typography>
        <Typography variant='body2' component='div' sx={{ marginTop: 2 }}>
          <span style={{ fontWeight: 'bold' }}>Enemy Wizard Calcs:</span> Big
          change here. Now we only make a calculation if the infil exists and is
          less that 1 tick old. Sot, Survey Sos need to be made on the current
          tick. As soon as all 3 conditions are true, we make the calculation
          and store the wizard count on the enemy. It persists so even when the
          enemy changes acres, the wpa is accurate based on the latest wizard
          count. To trigger a refresh, get a new Sot, Survey, Sos, Infiltrate in
          any order.
        </Typography>
        <Typography variant='body2' component='div' sx={{ marginTop: 2 }}>
          <span style={{ fontWeight: 'bold' }}>Expanded Row detail:</span> You
          can view additional info on the province by expanding the row. This
          will be expanded furth over next few weeks.
        </Typography>
        <Typography variant='body2' component='div' sx={{ marginTop: 2 }}>
          <span style={{ fontWeight: 'bold' }}>Column Reordering:</span> You can
          now drag and drop columns by grabbing the column header. This
          reordering affects all main tabs (not inc. Armies, Ops and Gains).
          This is done by dragging the column header.
        </Typography>
        <Typography variant='body2' component='div' sx={{ marginTop: 2 }}>
          <span style={{ fontWeight: 'bold' }}>Column Pinning:</span> You can
          temporarily pin columns left or right by hovering on column header and
          using the contextual menu (3 dots). It will not persist (yet) and will
          reset when switching away from main grid tabs to Armies, OPs and
          Gains, or page refresh. (Desktop only)
        </Typography>
        <Typography variant='body2' component='div' sx={{ marginTop: 2 }}>
          <span style={{ fontWeight: 'bold' }}>Column Widths:</span> You can
          also temporarily adjust the column widths but they resize
          automatically as you switch views. This is done by dragging the right
          edge of column header.
        </Typography>
        <Typography
          variant='body2'
          component='div'
          sx={{ marginTop: 2 }}
          gutterBottom
        >
          <span style={{ fontWeight: 'bold' }}>Spell Filters:</span> You can use
          the filter on the header contextual menu to filter by abreviated spell
          names e.g. GP, MS, FAN, FL
        </Typography>
      </Box> */}
    </>
  );
};

export default Legend;
